import { UpdateRequest } from "../../services/requestHelpers";
import { HttpMethods } from "../../utils/constants";

const handleRequest = async (url, data, method) => {
  const response = await UpdateRequest(url, data, method);

  let result = {};
  try {
    result = await response.json();
  } catch (e) {
    // Means no body
  }

  if (!response.ok) {
    return undefined;
  }

  return result;
};

export const syncTranslations = (data, baseUrl) => {
  const url = `${baseUrl}/translations`;
  return handleRequest(url, data, HttpMethods.Post);
};

export const syncTranslationsBulk = (data, baseUrl) => {
  const url = `${baseUrl}/translations/bulk`;
  return handleRequest(url, data, HttpMethods.Post);
};

export const deleteTranslation = (data, baseUrl) => {
  const url = `${baseUrl}/translations`;
  return handleRequest(url, data, HttpMethods.Delete);
};
